import { render } from "./CompanyRoles.vue?vue&type=template&id=369679d8"
import script from "./CompanyRoles.vue?vue&type=script&lang=js"
export * from "./CompanyRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/overlatelser/OvApplicationView/CompanyRoles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "369679d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('369679d8', __exports__)) {
    api.reload('369679d8', __exports__)
  }
  
  module.hot.accept("./CompanyRoles.vue?vue&type=template&id=369679d8", () => {
    api.rerender('369679d8', render)
  })

}


export default __exports__